import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/siteData';
import { formatRelative, formatViews } from '@/utils/format';

interface ArticleCardProps {
  article: Article;
  variant?: 'grid' | 'list';
}

export default function ArticleCard({ article, variant = 'grid' }: ArticleCardProps) {
  if (variant === 'list') {
    return (
      <article className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:p-4">
        <Link
          to={`/article/${article.id}`}
          className="relative h-24 w-32 shrink-0 overflow-hidden rounded-md md:h-28 md:w-44"
        >
          <img
            src={article.cover}
            alt={article.title}
            title={`${article.title} - 爆料吃瓜`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-center gap-2">
            <span className="rounded-sm bg-primary-100 px-2 py-0.5 font-label text-xs font-medium text-primary-700">
              {article.categoryName}
            </span>
            <span className="font-label text-xs text-foreground-500">{formatRelative(article.date)}</span>
          </div>
          <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
            <Link to={`/article/${article.id}`} className="transition-colors hover:text-primary-600">
              {article.title}
            </Link>
          </h3>
          <p className="mt-1.5 hidden line-clamp-2 font-body text-sm leading-relaxed text-foreground-600 sm:block">
            {article.excerpt}
          </p>
          <div className="mt-auto flex items-center gap-4 pt-2 font-label text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-sm"></i>
              {formatViews(article.views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-user-line text-sm"></i>
              {article.author}
            </span>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/article/${article.id}`} className="relative block h-44 w-full overflow-hidden">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 爆料吃瓜`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-sm bg-foreground-950/70 px-2 py-1 font-label text-xs text-background-50">
          {article.categoryName}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950">
          <Link to={`/article/${article.id}`} className="transition-colors hover:text-primary-600">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 font-body text-sm leading-relaxed text-foreground-600">
          {article.excerpt}
        </p>
        <div className="mt-auto flex items-center justify-between pt-4 font-label text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-sm"></i>
            {formatViews(article.views)} 围观
          </span>
          <span>{formatRelative(article.date)}</span>
        </div>
      </div>
    </article>
  );
}